import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { getImages, PlatformDockerImagesResponse } from 'api/platform';

type UsePlatformDockerImagesResult = Omit<UseQueryResult<PlatformDockerImagesResponse>, 'data'> &
  PlatformDockerImagesResponse;

export const usePlatformDockerImages = (
  queryOptions?: Omit<UseQueryOptions<PlatformDockerImagesResponse>, 'queryKey' | 'queryFn'>
): UsePlatformDockerImagesResult => {
  const platformImagesQuery = useQuery<PlatformDockerImagesResponse>({
    queryKey: ['platformImages'],
    queryFn: ({ signal }) => getImages(signal),
    ...queryOptions,
  });

  return {
    ...platformImagesQuery,
    images: platformImagesQuery.data?.images,
    latestVersion: platformImagesQuery.data?.latestVersion,
  };
};
